import {useState}                               from 'react'
import {OKCancel}                               from '../../lib/iprs-react-library/src/index.js';

import  {B_ACTIONS}                             from './bookingReducer'
                                                        
/* 
 * REACT componet to find let the use search for a CaseID
 */
const FindCase = ({api, bookingDispatch, setError}) => {

    const [caseID, setCaseID] =                              useState('')
    
    const handleChange = e => {
        e.preventDefault()
        
        setCaseID( e.target.value )
    }

    const cancelBooking = () => {
        bookingDispatch( B_ACTIONS.CANCEL_CONFIRM )
    }

    const clickHandler = e => {
        e.preventDefault()
        
        /* first lookup the internal pkCaseID then get patient data. Only take 
         * exact matches */
        api.getPatientOverviewExtID( caseID )
        .then( r => bookingDispatch( B_ACTIONS.PATIENT_DATA, r.apiResult ) )
        .catch( err => { setError( err.message ) })
    }

    return <>
    
        <form>
            <label className='form__label' htmlFor='caseID' >Enter the case ID</label>
            <input className='form__input'  name='caseID' value={caseID} onChange={handleChange} />
            <OKCancel onOK={clickHandler} okText={'Load Case'} onCancel={cancelBooking} />
        </form>
    </>
}

export default FindCase

